module.exports = __webpack_public_path__ + "img/about1.f0e9503c.svg";